import { useAuth, useAirborneAppConfig } from "@airborne/react-admin";
import * as React from "react";
import { FC } from "react";
import { EditProps } from "react-admin";
import CustomLinearProgress from "../../../src/Components/Progress/LinearProgress";

const MinioDownload: FC<EditProps> = props => {
  const { apiBaseUrl } = useAirborneAppConfig();
  const { tokens } = useAuth();
  const [loading, setLoading] = React.useState(false);
  React.useEffect(() => {
    if (props.id !== null) {
      setLoading(true);
      getMinioPdf();
    }
  }, []);
  const getMinioPdf = () => {
    fetch(`${apiBaseUrl}/minio/download/tt-api-pool/${props.id}?token=${tokens?.accessToken}`)
      .then(response => response.blob())
      .then(blob => {
        const url = URL.createObjectURL(blob);
        handleDownload(url);
      })
      .catch(error => {
        setLoading(false);
        throw new Error(error);
      });
  };
  const handleDownload = url => {
    const link = document.createElement("a");
    link.download = `${props.id}`;
    link.href = url;
    link.click();
    setLoading(false);
    window.close();
  };
  return <CustomLinearProgress loading={loading} periodTime={500} />;
};

export default MinioDownload;
